import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  notFirstLogin: false,
  isLoading: false,
  error: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
    },
    setUserLogin: (state) => {
      state.notFirstLogin = true;
    },
    fetchingUser: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, setUserLogin, fetchingUser } = userSlice.actions;
export const getUser = (state) => state.userReducer.user;
export const selectUserLoginStatus = (state) => state.userReducer.notFirstLogin;
export const isLoadingUser = (state) => state.userReducer.isLoading;
export default userSlice.reducer;
